export const SR_CONTRACT_START = 'SR_CONTRACT_START';
export const SR_CONTRACT_END = 'SR_CONTRACT_END';
export const SR_CONTRACT_DATA = 'SR_CONTRACT_DATA';
export const SR_CONTRACT_BY_ID = 'SR_CONTRACT_BY_ID';
export const SR_TYPE_CONFIG_DATA = 'SR_TYPE_CONFIG_DATA';
export const SR_TYPE_CONFIG_DATA_ID = 'SR_TYPE_CONFIG_DATA_ID';
export const SR_CONTRACT_RESET = 'SR_CONTRACT_RESET';
